import { LoadManager } from 'managers/LoadManager'

const name = 'LOAD'

async function execute() {
  return LoadManager.particleAssets()
}

export function getParticleLoadAction() {
  return {
    name,
    execute,
  }
}
